// extracted by mini-css-extract-plugin
export default {"grid":"BestSellerSection_grid__xXlhY"};